import { H3 } from '@zooplus/ui-components';
import { useTranslation } from '../../hooks/use-translations';
import React from 'react';
import styles from './UpcomingSubscriptions.module.scss';

import { SubscriptionInfo } from '../../model/subscriptionProducts';
import { Subscription } from './subscription';
import { TotalSavings } from './total-savings/TotalSavings';

export type UpcomingSubscriptionsProps = {
  subscriptions: SubscriptionInfo;
};

export const UpcomingSubscriptions = (props: UpcomingSubscriptionsProps) => {
  const { t } = useTranslation();

  return (
    <section>
      <H3 className={styles.title}>
        {t('upcoming-subscriptions.title', {
          count: props.subscriptions?.upcomingAutoshipments.length,
        })}
      </H3>
      <div className={styles.info}>
        {props.subscriptions?.upcomingAutoshipments.map((subscription, index: number) => {
          if (index < 3) {
            return (
              <Subscription
                status={subscription.status}
                name={subscription.alias}
                weeks={subscription.intervalDays}
                totalValue={subscription.total}
                nextOrderDate={new Date(subscription.nextRun)}
                articles={subscription.articles}
                autoshipId={subscription.id}
              />
            );
          } else {
            return <></>;
          }
        })}
        {props.subscriptions.totalSavings && (
          <TotalSavings
            totalSavingsFormatted={props.subscriptions.totalSavings}
            savingsSince={new Date(props.subscriptions.oldestAutoshipmentDate)}
          />
        )}
      </div>
    </section>
  );
};
